// Primary navigation: on-page anchors on the home page; from any other page
// the link routes back to the home anchor (see goTo fallbacks in Header/Footer).

export const NAV_ITEMS = [
  { id: "home", labelKey: "nav.home", href: "#home" },
  { id: "about", labelKey: "nav.about", href: "#about" },
  { id: "products", labelKey: "nav.products", href: "#products" },
  { id: "blog", labelKey: "nav.blog", href: "#news" },
  { id: "contact", labelKey: "nav.contact", href: "#contact" },
];

export const FOOTER_LINKS = {
  explore: [
    { labelKey: "nav.products", href: "#products" },
    { labelKey: "nav.about", href: "#about" },
    { labelKey: "nav.blog", href: "#news" },
    { labelKey: "nav.contact", href: "#contact" },
  ],
  company: [
    { labelKey: "footer.clientAccess", href: "/admin" },
    { labelKey: "footer.privacy", href: "/privacy" },
    { labelKey: "footer.terms", href: "/terms" },
  ],
};
